import { AsYouType, isValidPhoneNumber, parsePhoneNumberFromString } from "libphonenumber-js";

/** Digits-only national number (max 10 for IN mobiles). */
export function sanitizeIndianMobileInput(raw: string): string {
  const digits = raw.replace(/\D/g, "");
  // Strip leading 91 / 0 if user pastes full number
  let national = digits;
  if (national.startsWith("91") && national.length > 10) {
    national = national.slice(2);
  }
  if (national.startsWith("0") && national.length > 10) {
    national = national.slice(1);
  }
  return national.slice(0, 10);
}

/** Display value while typing, e.g. "98765 43210". */
export function formatIndianMobileDisplay(nationalDigits: string): string {
  if (!nationalDigits) return "";
  const formatter = new AsYouType("IN");
  return formatter.input(nationalDigits).replace(/^\+91\s?/, "").trim();
}

export function isValidIndianMobile(nationalDigits: string): boolean {
  if (!/^[6-9]\d{9}$/.test(nationalDigits)) return false;
  return isValidPhoneNumber(nationalDigits, "IN");
}

/** E.164 for API storage, e.g. +919876543210 */
export function toIndianE164(nationalDigits: string): string | null {
  if (!isValidIndianMobile(nationalDigits)) return null;
  const parsed = parsePhoneNumberFromString(nationalDigits, "IN");
  return parsed?.number ?? `+91${nationalDigits}`;
}

export function indianMobileHint(nationalDigits: string): string | null {
  if (!nationalDigits) return null;
  if (nationalDigits.length < 10) {
    return `Enter ${10 - nationalDigits.length} more digit${10 - nationalDigits.length === 1 ? "" : "s"}`;
  }
  if (!/^[6-9]/.test(nationalDigits)) {
    return "Indian mobiles start with 6, 7, 8, or 9";
  }
  if (!isValidIndianMobile(nationalDigits)) {
    return "Enter a valid Indian mobile number";
  }
  return null;
}
